import axios from "axios";
import { ElMessage } from "element-plus";
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// 防止401/403重复处理的标志
let isRefreshing = false;

const service = axios.create({
  baseURL: "/api",
  timeout: 5000,
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    if (store.getters.tenantInfo) {
      config.headers["tenantId"] = store.getters.tenantInfo.tenantId;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code !== 200) {
      if (res.code === 401 || res.code === 403) {
        // 防止重复处理
        if (isRefreshing) {
          return Promise.reject(new Error("未授权"));
        }
        isRefreshing = true;

        router.push("/403");
        isRefreshing = false;

        return Promise.reject(new Error("未授权"));
      }
      ElMessage({
        message: res.msg || "Error",
        type: "error",
        duration: 3000,
      });
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);
    ElMessage({
      message: error.message,
      type: "error",
      duration: 3000,
    });
    return Promise.reject(error);
  },
);

export default service;
